/* eslint-disable */
import {
  axios,
  config
} from '../api'
import store from '../store'

let role = {}

// 分页获取系统角色列表
role.getRoleList = {
  data: {
    PageIndex: 1,
    PageSize: 10,
    CondList: [
      //写到这儿再说吧，传条件的时候要注意格式
      // {
      //   Key: '',
      //   Operator: '',
      //   Value: ''
      // }
    ]
  },
  post(_data) {
    _data = _data ? _data : this.data
    return axios('post', config.API_URL + '/api/SysAuth/GetRoleList', _data)
  }
}

// 添加角色，code需要自己输入
role.addRole = {
  data: {
    Code: '',
    Name: '',
    Notes:''
  },
  post(_data) {
    _data = _data ? _data : this.data
    return axios('post', config.API_URL + '/api/SysAuth/AddRole', _data)
  }
}

// 修改角色，code需要自己输入
role.editRole = {
  data: {
    Code: ' ',
    Name: ' ',
    Notes: ' '
  },
  post(_data) {
    _data = _data ? _data : this.data
    return axios('post', config.API_URL + '/api/SysAuth/EditRole', _data)
  }
}

// 删除---
role.delRole = (_Code) => {
  return axios('post', config.API_URL + '/api/SysAuth/DelRole', {
    Code: _Code
  })
}

// 根据角色获取角色的权限---
role.getRoleAuthAndSysAuthList = (_Code) => {
  return axios('post', config.API_URL + '/api/SysAuth/GetRoleAuthAndSysAuthList',{}, {
    roleCode: _Code
  })
}

//设置角色权限
role.setRoleAuth = (_RoleCode,_OperateCodeList) => {
  return axios('post', config.API_URL + '/api/SysAuth/SetRoleAuth', {
    RoleCode: _RoleCode,
    OperateCodeList: _OperateCodeList //传的是string
  })
}

export default role



